import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

import DialogHeader from "../components/DialogHeader"

export default function ConfirmArchiveCandidatesDialog({
  open,
  candidateCount,
  onClose,
}) {
  function handleSoftClose() {
    onClose(false)
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader
        title={`Remove ${candidateCount} candidates?`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <Typography variant="body1" color="text.secondary">
          Selected candidates will be hidden from your portal (lists, pipeline,
          and search). The lead rows are not permanently deleted on our side.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={() => onClose(true)}>
          Remove from portal
        </Button>
      </DialogActions>
    </Dialog>
  )
}
